<icc-select-box
  [title]="'DOOR|Typ szyldu zamka głównego' | translate"
  [description]="(plateMainLock$ | async)?.name"
  [imageUrl]="(plateMainLockBoxSelect$ | async)?.imagePath"
  [buttonText]="'INTERFACE|Zmień' | translate"
  [buttonText2]="'INTERFACE|Opcje' | translate"
  (select)="selectPlateToMainLock()"
  (select2)="changePlateToMainLockOptions()"
  [descriptionTemplate]="typeBoxTemplate"
  [descriptionContext]="plateMainLockBoxSelect"
  [disabledButton1]="isPlatesToMainLockButtonDisabled()"
  [disabledButton2]="isPlatesToMainLockButton2Disabled()"
></icc-select-box>
@if ((plateAdditionalLock$ | async)) {
  <icc-select-box
    [title]="'DOOR|Typ szyldu zamka dodatkowego' | translate"
    [description]="(plateAdditionalLock$ | async)?.name"
    [imageUrl]="(plateAdditionalLockBoxSelect$ | async)?.imagePath"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changePlateToAdditionalLock()"
    [disabledButton1]="isPlatesToAdditionalLockButtonDisabled()"
    >
  </icc-select-box>
}

@if ((innerPlateAdditionalLock$ | async) && type === 'inner') {
  <icc-select-box
    [title]="'DOOR|Model szyldu zamka dodatkowego' | translate"
    [description]="(innerPlateAdditionalLock$ | async)?.name"
    [imageUrl]="(plateAdditionalLockBoxSelect$ | async)?.imagePath"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changePlateToAdditionalLock()"
    [disabledButton1]="isPlatesToAdditionalLockButtonDisabled()"
    >
  </icc-select-box>
}
@if ((outerPlateAdditionalLock$ | async) && type === 'outer') {
  <icc-select-box
    [title]="'DOOR|Model szyldu zamka dodatkowego zewnętrznego' | translate"
    [description]="(outerPlateAdditionalLock$ | async)?.name"
    [imageUrl]="(outerPlateAdditionalLockBoxSelect$ | async)?.imagePath"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeOuterPlateToAdditionalLock()"
    [disabledButton1]="isOuterPlatesToAdditionalLockButtonDisabled()"
    >
  </icc-select-box>
}

<ng-template #typeBoxTemplate let-name="name" let-color="color" let-description="description">
  <p> <b>{{ 'DOOR|Typ szyldu:' | translate }}</b> {{name}}</p>
  @if (color) {
    <p>
      <b>{{ 'DOOR|Kolor:' | translate }}</b> {{color}}
    </p>
  }
  <p ng-bind-html="description"></p>
</ng-template>
